import React from 'react';
import { CheckmarkIcon } from '../svg/CheckmarkIcon';
import { FeatureListItem } from './FeatureListItem';

type Props = {
    feature: FeatureListItem;
};

export const MobileFeatureListItem: React.FC<Props> = ({ feature }) => {
    const isHeader =
        !feature.free.included &&
        !feature.tier1.included &&
        !(feature.tier2 && feature.tier2.included) &&
        !(feature.tier3 && feature.tier3.included);

    return (
        <div className={`feature-list-item${isHeader ? ' header' : ''}`}>
            <div className="item-info-container">
                <h2 className="item-label">{feature.label}</h2>
                {feature.description && <p className="item-description">{feature.description}</p>}
            </div>
            {!isHeader && (
                <div className={`checkmarks${feature.tier3 ? ' has-four' : ''}`}>
                    <div className="checkmark-info-container">
                        <p className="descriptor">{feature.free.name}</p>
                        <div className="checkmark-container free">{feature.free.included && <CheckmarkIcon />}</div>
                    </div>
                    <div className="checkmark-info-container">
                        <p className="descriptor">{feature.tier1?.name}</p>
                        <div className="checkmark-container tier-one">
                            {feature.tier1?.included && <CheckmarkIcon />}
                        </div>
                    </div>
                    {feature.tier2 && (
                        <div className="checkmark-info-container">
                            <p className="descriptor">{feature.tier2.name}</p>
                            <div className="checkmark-container tier-two">
                                {feature.tier2?.included && <CheckmarkIcon />}
                            </div>
                        </div>
                    )}
                    {feature.tier3 && (
                        <div className="checkmark-info-container">
                            <p className="descriptor">{feature.tier3.name}</p>
                            <div className="checkmark-container tier-three">
                                {feature.tier3?.included && <CheckmarkIcon />}
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};
